import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { logoPlatform } from "../../../../../utils/string";
import Avatar from "@mui/material/Avatar";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  BOX_SHADOW_THEME,
  INPUT_COLOR_BORDER,
  LINEAR_GRADIENT_WHITE_CARD,
} from "../../../../../utils/colors";
import { BORDER_RADIUS } from "../../../../../utils/constants";
import { ConfirmAlert } from "../../../../../components/Alerts/Alerts";
import {
  DISCARD_OPTIMIZATION_ALERT_DESCRIPTION,
  DISCARD_OPTIMIZATION_ALERT_TITLE,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";

const InsightCard = ({
  id,
  title,
  previousContent = null,
  nextContent = null,
  sxTitle = {},
  previousContentTitle = null,
  platform,
  sx = {},
  index, // eslint-disable-line no-unused-vars
  onDiscardButtonClick = null,
  showDiscardButton = false,
  isOptimizationApplied = false,
  isOptimizationDiscarded = false,
  headerBadges = null,
}) => {
  const { t } = useTranslationApp();

  const onDiscardClick = async () => {
    const result = await ConfirmAlert({
      title: t(DISCARD_OPTIMIZATION_ALERT_TITLE),
      text: t(DISCARD_OPTIMIZATION_ALERT_DESCRIPTION),
    });

    if (result.isConfirmed && onDiscardButtonClick) {
      onDiscardButtonClick();
    }
  };

  return (
    <Box
      id={id}
      sx={{
        border: `1px solid ${INPUT_COLOR_BORDER}`,
        boxShadow: BOX_SHADOW_THEME,
        background: LINEAR_GRADIENT_WHITE_CARD,
        borderRadius: `${BORDER_RADIUS * 4}px !important`,
        p: 2,
        position: "relative",
        ...sx,
      }}
    >
      {previousContentTitle && previousContentTitle}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          mb: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            flexWrap: "wrap",
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              flexShrink: 0,
              background: "linear-gradient(135deg, #ffffff 0%, #fafafa 100%)",
              border: "1px solid rgba(0, 0, 0, 0.06)",
              borderRadius: 2,
            }}
          >
            {platform ? (
              <Avatar
                data-hide-in-pdf-capture
                src={logoPlatform(platform)}
                variant="square"
                sx={{
                  width: 25,
                  height: 25,
                  ".MuiAvatar-img": { objectFit: "contain" },
                }}
              />
            ) : null}
          </Box>
          {headerBadges}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {showDiscardButton &&
            !isOptimizationDiscarded &&
            !isOptimizationApplied && (
              <IconButton
                onClick={onDiscardClick}
                size="small"
                sx={{
                  padding: 0.5,
                  color: "text.secondary",
                  "&:hover": {
                    color: "error.main",
                    backgroundColor: "rgba(211, 47, 47, 0.08)",
                  },
                }}
              >
                <DeleteOutlineIcon sx={{ fontSize: 24 }} />
              </IconButton>
            )}
        </Box>
      </Box>

      {/* Title Section */}
      {title && (
        <Box>
          <Box>
            <Typography
              fontSize={"1.2rem"}
              variant="subtitle1"
              fontWeight="600"
              sx={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
                lineHeight: 1.35,
                ...sxTitle,
              }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
      )}

      {previousContent}

      {/* Additional Content */}
      {nextContent}
    </Box>
  );
};

export default InsightCard;
